import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_4 = { class: "tw-flex tw-items-center tw-w-[95%]" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["data-cy"]
const _hoisted_7 = ["data-cy"]

import { PropType, onMounted, ref, watch } from "vue";
import BaseDropDownItem from "@/components/common/form/baseDropDownItem.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import ArrowIcon from "@/components/svgs/arrowIcon.vue";
import store from "@/store";
import { OVERLAY_KEYBOARD } from "@/utils/constants";
import { RecycleScroller } from "vue-virtual-scroller";
import ArrowIconDropdown from "@/components/svgs/arrowIconDropdown.vue";
import VRuntimeTemplate from "vue3-runtime-template";


export default /*#__PURE__*/_defineComponent({
  __name: 'baseDropDown',
  props: {
  /** The model and value of the input */
  modelValue: {
    type: [Array, Number, String, Object, null] as PropType<unknown>,
    required: true,
  },
  /** Id of input */
  id: {
    type: String,
    required: true,
  },
  dataCyId: {
    type: String,
    required: false,
    default: "",
  },
  /** CSS class name */
  className: {
    type: String,
    default: "",
  },
  classTextName: {
    type: String,
    default: "",
  },
  /** Placeholder text for the input */
  placeholder: {
    type: String,
    default: "",
  },
  /** Data of dropdown options */
  data: {
    type: Array as PropType<IDropDownData[]>,
    required: true,
  },
  /** Description text for the input */
  description: {
    type: String,
    default: "",
  },
  /** Vue Validation object */
  validation: {
    type: Object,
    default: () => ({}),
  },
  customSelectContainer: {
    type: String,
    required: false,
    default: "",
  },
  useVisualScroll: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  isOptionButtonDropdown: {
    type: Boolean,
    required: false,
    default: false,
  },
  bgDropdown: {
    type: String,
    required: false,
    default: "#eff0f180",
  },
  textOptionButtonDropdown: {
    type: String,
    required: false,
    default: "",
  },
  showValidate: {
    type: Boolean,
    required: false,
    default: false,
  },
  validClass: { type: String, required: false, default: "" },
},
  emits: [
  "update:modelValue",
  "update:openDropdown",
  "onClickBtnDropdown",
],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "1994b261": (__props.bgDropdown)
}))


const isDropdownOpen = ref(false);
const activeItem = ref(0);
const currentValue = ref<IDropDownData>({} as IDropDownData);

onMounted(() => {
  const matchingOption = props.data.find(
    (item) => item.name === props.modelValue,
  );
  // If a matching option is found, assign its value to currentValue
  if (matchingOption) {
    currentValue.value = matchingOption;
  }
});


const handleSelect = (optionId, optionData?) => {
  currentValue.value = optionId;
  setTimeout(() => {
    store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.MODAL);
  }, 1000);
  emit("update:modelValue", currentValue.value, optionData);
};
const showDropdow = () => {
  store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.DROPDOWN); //
};
const selectItem = (event) => {
  if (event.key == "ArrowDown") {
    isDropdownOpen.value = true;
    store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.DROPDOWN);
  }
  if (event.key == "Enter") {
    let id: any = props.data[activeItem.value].id;
    handleSelect(id);
    isDropdownOpen.value = false; // close dropdow when select value
    setTimeout(() => {
      store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.MODAL);
    }, 1000);
  }
};
const moveSelectionDown = (step) => {
  if (props.data.length - 1 == activeItem.value) {
    activeItem.value = props.data.length - 1;
  } else if (activeItem.value < props.data.length) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop += 61;
    }
  }
};
const moveSelectionUp = (step) => {
  if (activeItem.value >= 1) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop -= 61;
    }
  }
};

const handleClickBtnDropdown = () => {
  emit("onClickBtnDropdown");
};

watch(isDropdownOpen, (newValue, oldValue) => {
  emit("update:openDropdown", isDropdownOpen.value);
  if (!newValue && oldValue) {
    setTimeout(() => {
      store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.MODAL);
    }, 1000);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_BDropdown = _resolveComponent("BDropdown")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!
  const _component_b_row = _resolveComponent("b-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`tw-relative w-100 ${
      __props.disabled ? 'tw-text-[#B7B7B7] tw-pointer-events-none' : ''
    }`)
  }, [
    _createVNode(_component_BDropdown, {
      id: props.id,
      modelValue: isDropdownOpen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isDropdownOpen).value = $event)),
      class: _normalizeClass([
        'tw-relative baseDropDown',
        'focusDrop ',
        __props.className,
        __props.validation.$error ? 'invalid' : '',
      ]),
      block: "",
      "menu-class": "w-100",
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(($event: any) => (moveSelectionDown(1)), ["down"])),
        _cache[2] || (_cache[2] = _withKeys(($event: any) => (moveSelectionUp(-1)), ["up"])),
        selectItem
      ],
      onShow: showDropdow
    }, {
      "button-content": _withCtx(() => [
        _renderSlot(_ctx.$slots, "button-content", {}, () => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (
                  props.data.find((item) => item.id === __props.modelValue)?.iconSrc ||
                  props.data[0]?.iconSrc
                )
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    alt: "",
                    class: "tw-mr-[5px] tw-w-[20px] tw-h-[20px] tw-object-contain",
                    src: 
                  props.data.find((item) => item.id === __props.modelValue)?.iconSrc ||
                  props.data[0]?.iconSrc ||
                  ''
                
                  }, null, 8, _hoisted_5))
                : _createCommentVNode("", true),
              (
                  props.data?.[0] &&
                  props.data.some((item) => item.id === __props.modelValue)
                )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(` ${
                  __props.disabled ? 'tw-text-[#B7B7B7]' : 'tw-text-[#231F20]'
                } tw-truncate text-dropdown ${__props.classTextName} ${
                  props.data.find((item) => item.id === __props.modelValue)?.color
                    ? `tw-text-[${
                        props.data.find((item) => item.id === __props.modelValue)?.color
                      }]`
                    : ''
                }`),
                    "data-cy": __props.dataCyId
                  }, _toDisplayString(props.data.find((item) => item.id === __props.modelValue)?.name), 11, _hoisted_6))
                : (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    "data-cy": __props.dataCyId,
                    class: _normalizeClass([__props.customSelectContainer])
                  }, _toDisplayString(__props.placeholder), 11, _hoisted_7))
            ]),
            _createVNode(ArrowIconDropdown, { class: "right-arrow" })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          (__props.useVisualScroll)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(RecycleScroller), {
                  class: "scroller",
                  items: props.data,
                  "item-size": 56,
                  "key-field": 'id'
                }, {
                  default: _withCtx(({ item, index }) => [
                    (_openBlock(), _createBlock(BaseDropDownItem, {
                      id: item.id.toString(),
                      key: item.id.toString(),
                      "data-cy": `base-dropdown-item-${item.id.toString()}`,
                      text: item.name || '',
                      "class-name": `normal-dropdown-container 'focusDrop' ${
                activeItem.value === index ? 'activeItem' : ''
              }`,
                      onClick: ($event: any) => (handleSelect(item.id, item))
                    }, null, 8, ["id", "data-cy", "text", "class-name", "onClick"]))
                  ]),
                  _: 1
                }, 8, ["items"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (option) => {
                    return (_openBlock(), _createBlock(BaseDropDownItem, {
                      id: option.id.toString(),
                      key: option.id.toString(),
                      "data-cy": `base-dropdown-item-${option.id.toString()}`,
                      text: option.name,
                      "class-name": `normal-dropdown-container  'focusDrop' ${
                props.modelValue === option.id ? 'activeItem' : ''
              } ${option.color ? `tw-text-[${option.color}]` : ''} `,
                      "color-text-hover": option.color,
                      onClick: ($event: any) => (handleSelect(option.id, option))
                    }, null, 8, ["id", "data-cy", "text", "class-name", "color-text-hover", "onClick"]))
                  }), 128))
                ])
              ]))
        ])
      ]),
      _: 3
    }, 8, ["id", "modelValue", "class"]),
    (__props.validation?.$errors?.[0]?.$message && __props.showValidate)
      ? (_openBlock(), _createBlock(_component_b_row, {
          key: 0,
          class: "tw-items-center"
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "feedback", {}, () => [
              _createElementVNode("div", {
                class: _normalizeClass(`${__props.validClass} tw-ml-[15px]`)
              }, [
                _createVNode(_component_b_form_invalid_feedback, {
                  class: _normalizeClass({ 'is-invalid': __props.validation.$error })
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(VRuntimeTemplate), {
                      template: __props.validation?.$errors?.[0]?.$message
                    }, null, 8, ["template"])
                  ]),
                  _: 1
                }, 8, ["class"])
              ], 2)
            ])
          ]),
          _: 3
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})